import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Question} from '../../models/underwriter.model';
import { Geolocation } from '@capacitor/geolocation';
import {getParam} from '../question-helper';

declare const $: any;

@Component({
    selector: 'app-question-location',
    templateUrl: './question-location.component.html',
    styleUrls: ['./question-location.component.scss'],
    standalone: false
})
export class QuestionLocationComponent implements OnInit, AfterViewInit {

  @ViewChild('addressText') addressText: ElementRef;
  @ViewChild('gmap') gmapElement: any;
  @Input() question: Question;
  @Input() readonly = false;
  @Input() showLabel = false;
  @Output() questionAnswer = new EventEmitter<any>();

  map: google.maps.Map = null as any;
  marker: google.maps.Marker = null as any;
  notify: any;
  apartmentNo: any;
  complex: any;
  streetAddress: any;
  suburb: any;
  province: any;
  city: any;
  postalCode: any;
  provinces: any = [
    {value: '', label: 'Select Province'},
    {value: 'EC', label: 'Eastern Cape'},
    {value: 'FS', label: 'Free State'},
    {value: 'GP', label: 'Gauteng'},
    {value: 'KZN', label: 'KwaZulu-Natal'},
    {value: 'LP', label: 'Limpopo'},
    {value: 'MP', label: 'Mpumalanga'},
    {value: 'NC', label: 'Northern Cape'},
    {value: 'NW', label: 'North West'},
    {value: 'WC', label: 'Western Cape'}
  ];
  locationForm = new FormGroup({
    apartmentNo: new FormControl(''),
    complex: new FormControl(''),
    streetAddress: new FormControl('', Validators.required),
    suburb: new FormControl('', Validators.required),
    province: new FormControl(''),
    city: new FormControl('', Validators.required),
    postalCode: new FormControl('', Validators.required)
  });
  skipped = false;
  showSkip = false;
  parameter: any;
  constructor(private ref: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    if (getParam(this.parameter, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }
    
  }

  ngAfterViewInit(): void {
    /*setTimeout(() => {

    }, 500);*/ // Delay map to allow animation to finish

    this.initMap();
    this.getPlaceAutocomplete();
    setTimeout(() => {
      if (this.question?.answer) {
        let address: any;
        try { address = JSON.parse(this.question.answer); } catch { }
        if (!address) { return; }
        this.locationForm.controls.apartmentNo.setValue(address.apartmentNo);
        this.locationForm.controls.complex.setValue(address.complex);
        this.locationForm.controls.streetAddress.setValue(address.streetAddress);
        this.locationForm.controls.suburb.setValue(address.suburb);
        this.locationForm.controls.province.setValue(address.province);
        this.locationForm.controls.city.setValue(address.city);
        this.locationForm.controls.postalCode.setValue(address.postalCode);
        this.province = address.province;
      }
    });

    this.onChanges();
  }

  locateMe(): void {
    $('#map-wrap').removeClass('d-none');
    this.getCurrentPosition();
  }

  initMap(): void {
    const mapCenter = new google.maps.LatLng(-26.1714402, 28.0050051); // jhb
    const mapProp = {
      center: mapCenter,
      zoom: 5,
      mapTypeControl: false,
      streetViewControl: false,

    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    const markerImage = {
      url: 'assets/3/icn/marker.png',
      size: new google.maps.Size(77, 54),
      scaledSize: new google.maps.Size(77, 54),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(20, 50)
    };

    this.marker = new google.maps.Marker({
      map: this.map,
      draggable: true,
      icon: markerImage
    });

    this.map.setCenter(mapCenter);
    this.marker.setPosition(mapCenter);
    this.marker.setVisible(true);

    // listen for marker drag
    google.maps.event.addListener(this.marker, 'dragend', () => {
      this.getCodePosition(this.marker.getPosition(), false);
    });
  }

  getPlaceAutocomplete(): void {
    if (this.addressText) {
      const autocomplete = new google.maps.places.Autocomplete(this.addressText.nativeElement, {
        componentRestrictions: {country: 'ZA'}
      });

      autocomplete.setFields([
        'address_components',
        'geometry',
        'icon',
        'name',
      ]);

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place?.address_components) {
          console.log('No details available for input: \'' + place.name + '\'');
          return;
        } else {
          this.populateAddress(place.address_components);
        }
      });

      google.maps.event.addDomListener(this.addressText?.nativeElement, 'focus', e => {
        const target = e.target as HTMLInputElement;
        target?.setAttribute('autocomplete', 'new-add');
      });
    }
  }


  getCurrentPosition(): void {

    Geolocation.getCurrentPosition().then(p => {
      console.log(p.coords);
      const pos = {
        lat: p.coords.latitude,
        lng: p.coords.longitude
      };

      this.getCodePosition(pos, true);

    }).catch( error => {
      console.log(error);
      if (error.code === 1) {
          this.notify.init({
            message: 'Please enable "location services" for your browser in your Settings in order for us to determine your location.', // required
            icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'info',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
          return;
        } else {
          this.notify.init({
            message: 'We we unable to determine your location automatically. Please drag the marker to indicate your location.', // required
            icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
            size: 'lg',     // default: null; options: 'lg'
            style: 'info',  // default: null; options: 'info', 'success',
            close: true,    // default: false (close button enabled, auto-close duration removed)
            speed: 350,     // default: 350 (fade in/out speed)
            duration: 5000  // default: 5000 (duration active)
          });
          return;
        }

    });
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     const pos = {
    //       lat: position.coords.latitude,
    //       lng: position.coords.longitude
    //     };

    //     this.getCodePosition(pos, true);

    //   }, (error) => {
        
    //   });
    // }
  }

  getCodePosition(pos: any, gotPosition: boolean): void {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({location: pos}, (results, status: string) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (gotPosition) {
          this.map?.setCenter(pos);
          this.map?.setZoom(18);
          this.marker?.setPosition(pos);
        }
        this.populateGPSCoords(results[0]?.geometry?.location);
        this.populateAddress(results[0]?.address_components);
      } else {
        console.log('error, cannot determine the address at this location');
      }
    });
  }

  populateGPSCoords(location: any): void {
    const gpsInput = $('#address_gps-1');
    gpsInput.val(location.lat() + ', ' + location.lng());
  }

  populateAddress(addressComponents: any): void {
    let addressStreetNumber;
    let addressStreetName;
    this.streetAddress = '';
    this.suburb = '';
    this.city = '';
    this.province = '';
    this.postalCode = '';
    this.locationForm.controls.streetAddress.setValue('');
    this.locationForm.controls.suburb.setValue('');
    this.locationForm.controls.city.setValue('');
    this.locationForm.controls.province.setValue('');
    this.locationForm.controls.postalCode.setValue('');

    // not sure if this might require some tweaking ...only tested on a few addresses
    for (const item of addressComponents) {
      // street incl. number
      if (item.types.indexOf('street_number') !== -1) {
        addressStreetNumber = item.short_name;
      }

      // Street Name
      if (item.types.indexOf('route') !== -1) {
        addressStreetName = item.long_name;
      }

      // Street Number
      if (addressStreetNumber) {
        // has both name and number
        if (addressStreetName) {
          this.locationForm.controls.streetAddress.setValue(`${addressStreetNumber} ${addressStreetName}`);
          // only number (even possible?)
        } else {
          this.locationForm.controls.streetAddress.setValue(addressStreetNumber);
        }
        // only name
      } else if (addressStreetName) {
        this.locationForm.controls.streetAddress.setValue(addressStreetName);
      }


      // suburb
      if ((item.types.indexOf('sublocality') !== -1
          || item.types.indexOf('sublocality_level_1') !== -1
          || item.types.indexOf('sublocality_level_2') !== -1)
        && item.types.indexOf('political') !== -1) {
        this.suburb = item.short_name;
        this.locationForm.controls.suburb.setValue(this.suburb);
      }

      // city
      if (item.types.indexOf('locality') !== -1 && item.types.indexOf('political') !== -1) {
        this.city = item.short_name;
        this.locationForm.controls.city.setValue(this.city);
      }

      // province
      if (item.types.indexOf('administrative_area_level_1') !== -1 && item.types.indexOf('political') !== -1) {
        this.province = item.short_name;
        this.locationForm.controls.province.setValue(this.province);
      }

      // postal code
      if (item.types.indexOf('postal_code') !== -1) {
        this.postalCode = item.short_name;
        this.locationForm.controls.postalCode.setValue(this.postalCode);
      }
      this.ref.detectChanges();
    }

  }

  combinedAddress(): any {
    this.apartmentNo = this.locationForm.get('apartmentNo')?.value;
    this.complex = this.locationForm.get('complex')?.value;
    this.streetAddress = this.locationForm.get('streetAddress')?.value;
    this.suburb = this.locationForm.get('suburb')?.value;
    this.province = this.locationForm.get('province')?.value;
    this.city = this.locationForm.get('city')?.value;
    this.postalCode = this.locationForm.get('postalCode')?.value;

    const address = {
      apartmentNo: this.apartmentNo,
      complex: this.complex,
      streetAddress: this.streetAddress,
      suburb: this.suburb,
      province: this.province,
      city: this.city,
      postalCode: this.postalCode
    };

    return JSON.stringify(address);
  }

  changeProvince(event: any): void {
    this.province = event;
    this.locationForm.get('province').setValue(this.province);
  }

  onChanges(): void {
    this.locationForm.valueChanges.subscribe(() => {
      if (this.locationForm.valid) {
        this.submitResponse();
      }
    });
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }
  submitResponse(): void {
    if (this.question) {
      this.question.answer = this.combinedAddress();
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(this.combinedAddress());
    }
  }

}
